import { render, staticRenderFns } from "./RundownEditor.vue?vue&type=template&id=5b4d2aa6&"
import script from "./RundownEditor.vue?vue&type=script&lang=js&"
export * from "./RundownEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports